import Navbar from './components/Navbar';
import Footer from './components/Footer';
import './App.css';

function ParkRules() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <div className="relative h-[300px] md:h-[500px] mt-16 md:mt-24">
        <img 
          src="/a4.webp" 
          alt="Park Rules" 
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black bg-opacity-30"></div>
      </div>

      {/* Content Section */}
      <section className="py-12 md:py-16 bg-white">
        <div className="max-w-[1200px] mx-auto px-4 md:px-6">
          <h1 className="text-3xl md:text-5xl font-bold text-center mb-8 md:mb-12 uppercase italic tracking-wider" style={{ color: '#F5A623' }}>
            Rules and Regulations
          </h1>

          {/* Prior to Arrival */}
          <div className="mb-8 md:mb-12">
            <h2 className="text-xl md:text-2xl font-bold mb-4 md:mb-6">PRIOR TO ARRIVAL:</h2>
            <ul className="space-y-3 text-gray-800 leading-relaxed text-sm md:text-base">
              <li>• Please read all rules prior to your first trip to Throttle Edge.</li>
              <li>• Please fill out waiver forms located on our website before your first trip of the year to Throttle Edge.</li>
              <li>• Minor waiver forms must be completed by a legal guardian.</li>
              <li>• Spectators and/or participants on the property hereby assume all risks and injuries or damages resulting thereform.</li>
              <li>• If you are uncertain of any of our rules and guidelines, please check with our staff.</li>
              <li>• Our trails are closed until May.</li>
            </ul>
          </div>

          {/* Daily Rules */}
          <div className="mb-8 md:mb-12">
            <h2 className="text-xl md:text-2xl font-bold mb-4 md:mb-6">DAILY RULES:</h2>
            <ul className="space-y-3 text-gray-800 leading-relaxed text-sm md:text-base">
              <li>• All guests must stop and check-in at our Pro Shop upon arrival.</li>
              <li>• Every guest who is riding or participating in an event at Throttle Edge must have completed a waiver form, paid and checked in at our Pro Shop prior to parking and riding.</li>
              <li>• If a guest begins to ride without checking in/paying at our Pro Shop the result will be a minimum PKR 41,400 fine. This includes golf cart drivers who are not checked in.</li>
              <li>• Day parking is located in our south grass field between the peewee track and main track.</li>
              <li>• No motorized vehicles permitted on the beach, including dirt bikes, ATVs, e-bikes, golf carts, and side-by-sides.</li>
              <li>• We have a speed limit of 15 km/h in our pit area and parking fields. This rule is for all vehicles, dirt bikes, ATV's, and Side by Sides.</li>
              <li>• We do not allow machines to be running outside of riding hours.</li>
              <li>• There is absolutely no riding in the grass fields or any other grass areas at Throttle Edge. This includes all bikes, ATV's and side by sides. Failing to follow this rule will result in a PKR 41,400 fine.</li>
              <li>• There is no riding on our grass sound barrier or on the infields of the tracks. Failing to follow this rule will result in a PKR 41,400 fine.</li>
              <li>• Proper riding gear is required. It is mandatory to wear a proper full face off-road helmet, over the ankle boots, eye protection, long sleeves and pants.</li>
              <li>• Additional recommended safety gear: chest protector, neck brace, mouth guard, knee guards and elbow guards.</li>
              <li>• Helmets are required on all machines at all times. This includes riding in the pits to the courses.</li>
              <li>• All tracks and trails are one-directional. Make sure you understand which direction each course follows before entering.</li>
              <li>• Enter and exit the track and trails at the designated entrance point.</li>
              <li>• Do not at any point cut the track or trails when riding.</li>
              <li>• Make sure that you are riding the correct track for your model size and skill level.</li>
              <li>• Double riding is only permitted in Side by Sides and 2-up ATV's.</li>
              <li>• The use of drugs and alcohol is not permitted prior to or during riding at Throttle Edge.</li>
              <li>• Do not dump any oil on the ground. The result of draining your oil on the ground is a PKR 414,000 fine.</li>
              <li>• Clean up after yourself prior to leaving, please use our trash cans.</li>
              <li>• Swimming and fishing is permitted, however all minors must be accompanied by an adult.</li>
              <li>• We ask that all guests use common sense and express courtesy towards their fellow racers and to the staff.</li>
            </ul>
          </div>

          {/* Bicycles, E-Bicycles, E-Bikes */}
          <div className="mb-8 md:mb-12">
            <h2 className="text-xl md:text-2xl font-bold mb-4 md:mb-6">BICYCLES, E-BICYCLES, E-BIKES, AND SCOOTERS</h2>
            
            <h3 className="text-lg md:text-xl font-bold mb-3 md:mb-4 mt-6">BICYCLES:</h3>
            <ul className="space-y-3 text-gray-800 leading-relaxed mb-6 text-sm md:text-base">
              <li>• All bicycle riders under 18 must wear a helmet at all times.</li>
              <li>• Bicycles are permitted to use the trails and Stacyc/bicycle track when they are open.</li>
              <li>• Bicycles may be ridden in the pits after hours but must be off of the trails by dusk.</li>
              <li>• Wrist bands and payment are NOT required for bicycle riders.</li>
            </ul>

            <h3 className="text-lg md:text-xl font-bold mb-3 md:mb-4 mt-6">E-BICYCLES:</h3>
            <ul className="space-y-3 text-gray-800 leading-relaxed mb-6 text-sm md:text-base">
              <li>• E-bicycles are defined as bicycles with battery powered pedal assist. No throttle.</li>
              <li>• All E-bicycle riders under 18 must wear a helmet at all times.</li>
              <li>• E-bicycles are permitted to use the trails and Stacyc/bicycle track when they are open.</li>
              <li>• All speed limits are in effect with a max of 15 km/h in the pits.</li>
              <li>• Wrist bands and payment are NOT required for E-bicycle riders.</li>
            </ul>

            <h3 className="text-lg md:text-xl font-bold mb-3 md:mb-4 mt-6">E-BIKES:</h3>
            <ul className="space-y-3 text-gray-800 leading-relaxed mb-6 text-sm md:text-base">
              <li>• E-Bikes are defined as battery powered bikes that have a throttle.</li>
              <li>• All E-bike riders must wear a helmet at all times.</li>
              <li>• E-bikes may only be ridden inside of designated riding hours.</li>
              <li>• Wrist bands and payment ARE required for E-bike riders.</li>
            </ul>

            <h3 className="text-lg md:text-xl font-bold mb-3 md:mb-4 mt-6">STACYC:</h3>
            <ul className="space-y-3 text-gray-800 leading-relaxed mb-6 text-sm md:text-base">
              <li>• All Stacyc riders must wear a helmet at all times.</li>
              <li>• Stacyc's may only be ridden inside of designated riding hours.</li>
              <li>• Stacyc's may use the Stacyc and beginner tracks.</li>
              <li>• Wrist bands and payment ARE required for Stacyc riders.</li>
            </ul>
          </div>

          {/* Pit Vehicles */}
          <div className="mb-8 md:mb-12">
            <h2 className="text-xl md:text-2xl font-bold mb-4 md:mb-6">PIT VEHICLES:</h2>
            <p className="text-gray-800 leading-relaxed mb-4 text-sm md:text-base">Using your motorcycle, E-bike or ATV as a pit vehicle at Throttle Edge is prohibited, NO EXCEPTIONS.</p>
            
            <h3 className="text-lg md:text-xl font-bold mb-3 md:mb-4 mt-6">GOLF CARTS:</h3>
            <ul className="space-y-3 text-gray-800 leading-relaxed text-sm md:text-base">
              <li>• You must sign-in and pay to use your golf cart PRIOR to driving it.</li>
              <li>• You must be a minimum of 16 years old and have a valid drivers licence.</li>
              <li>• Your maximum passengers cannot exceed the amount of seats in your golf cart.</li>
              <li>• Golf carts are not permitted after dark.</li>
              <li>• ATV's and Side by sides are not considered Golf Carts and cannot be used as pit vehicles.</li>
            </ul>
          </div>

          {/* Camping Rules */}
          <div className="mb-8 md:mb-12">
            <h2 className="text-xl md:text-2xl font-bold mb-4 md:mb-6">CAMPING RULES:</h2>
            <ul className="space-y-3 text-gray-800 leading-relaxed text-sm md:text-base">
              <li>• Overnight parking (camping) is permitted at Throttle Edge.</li>
              <li>• Every vehicle that parks overnight must purchase a PKR 6,210 camping tag prior to your overnight stay.</li>
              <li>• Campfires are allowed, but must be in a raised fire pit which you must provide.</li>
              <li>• Throttle Edge does have firewood available for PKR 2,484 per bag.</li>
              <li>• All noise levels at minimal after 11pm.</li>
              <li>• Please check ahead for gate closing times.</li>
            </ul>
          </div>

          {/* Event Rules */}
          <div className="mb-8 md:mb-12">
            <h2 className="text-xl md:text-2xl font-bold mb-4 md:mb-6">EVENT RULES:</h2>
            <ul className="space-y-3 text-gray-800 leading-relaxed text-sm md:text-base">
              <li>• During events all guests must follow our Throttle Edge rule guide but also the additional rules put in place by event coordinators.</li>
              <li>• If you are uncertain of any of our rules and guidelines, please check with our staff.</li>
            </ul>
          </div>

          {/* Training and Rentals */}
          <div className="mb-8 md:mb-12">
            <h2 className="text-xl md:text-2xl font-bold mb-4 md:mb-6">TRAINING AND RENTALS:</h2>
            <ul className="space-y-3 text-gray-800 leading-relaxed text-sm md:text-base">
              <li>• When booking a reservation, the deposit is non-refundable for a no-show.</li>
              <li>• We do allow deposits to be used for rescheduling if we are notified within 24 hours.</li>
              <li>• Please show up a minimum of 15 minutes prior to the session.</li>
              <li>• If machines are being mis-treated, the session will end immediately without refund.</li>
              <li>• All damages to rental units will be paid out by the renter.</li>
              <li>• We supply safety equipment to all students and renters.</li>
              <li>• A credit card number is required to rent a bike.</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Image Gallery Section */}
      <section className="py-0 bg-white">
        <div className="max-w-[1200px] mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-0">
            {/* Top Left - Track Image */}
            <div className="relative h-[300px] md:h-[400px]">
              <img 
                src="/champ.webp" 
                alt="Throttle Edge Track" 
                className="w-full h-full object-cover"
              />
            </div>

            {/* Top Right - Group Photo */}
            <div className="relative h-[300px] md:h-[400px]">
              <img 
                src="/honda.webp" 
                alt="Throttle Edge Community" 
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-0">
            {/* Bottom Left - Inflatable */}
            <div className="relative h-[250px] md:h-[300px]">
              <img 
                src="/sec.webp" 
                alt="Activities" 
                className="w-full h-full object-cover"
              />
            </div>

            {/* Bottom Center - Swimming */}
            <div className="relative h-[250px] md:h-[300px]">
              <img 
                src="/a4.webp" 
                alt="Swimming Area" 
                className="w-full h-full object-cover"
              />
            </div>

            {/* Bottom Right - Aerial Track View */}
            <div className="relative h-[250px] md:h-[300px]">
              <img 
                src="/a3.jpeg" 
                alt="Aerial Track View" 
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default ParkRules;
